import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-receipts-branch',
  templateUrl: './payment-receipts-branch.component.html',
  styleUrls: ['./payment-receipts-branch.component.scss']
})
export class PaymentReceiptsBranchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
